import { render, staticRenderFns } from "./ViInvoiceFeePlanStudentList.vue?vue&type=template&id=aaea1188"
import script from "./ViInvoiceFeePlanStudentList.vue?vue&type=script&lang=js"
export * from "./ViInvoiceFeePlanStudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports